var React = require('react');

function Switch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.88889 7.77779L0 12.6667L4.88889 17.5556V13.8889H13.4444V11.4445H4.88889V7.77779ZM22 5.33335L17.1111 0.444458V4.11112H8.55556V6.55557H17.1111V10.2222L22 5.33335Z"}));
}

Switch.defaultProps = {"width":"22","height":"18","viewBox":"0 0 22 18","fill":"none"};

module.exports = Switch;

Switch.default = Switch;
